export default import.meta.ROLLUP_FILE_URL_gAxOnqCGujQ8HScIArzD0w